import React from 'react'

import CampaignDatesSection from './CampaignDatesSection'
import InventoryAccessAndAllocationSection from './InventoryAccessAndAllocationSection'

const GamOnsiteRightCreateSections = ({ formik }) => {
  return (
    <>
      <CampaignDatesSection formik={formik} />
      <InventoryAccessAndAllocationSection formik={formik} />
    </>
  )
}

export default GamOnsiteRightCreateSections
